import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import BaseModal from '../../Components/ComponentModal';
import ModalActions from './ComponentModalActions';
const ComponentModal = ({ item }) => {
    if (item) {
        return (_jsx(BaseModal, Object.assign({ modalKey: "notification", title: item.title }, { children: _jsxs("div", { children: [_jsx("div", { dangerouslySetInnerHTML: { __html: item.content } }), _jsx(ModalActions, { item: item })] }) })));
    }
    return null;
};
ComponentModal.propTypes = {
    item: PropTypes.shape({
        title: PropTypes.string.isRequired,
        content: PropTypes.string.isRequired
    })
};
const mapStateToProps = (state) => ({ item: state.notifications.items.find((notification) => notification.id === state.notifications.modalItemId) });
export default connect(mapStateToProps)(ComponentModal);
